exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dots-item[data-v-05011139] {\r\n  padding: 10px 5px;\r\n  color: #6d7d89;\r\n  line-height: 18px;\r\n  text-align: center;\r\n  border-radius: 20px;\r\n  box-shadow: 0 4px 10px rgba(44, 145, 179, 0.3);\r\n  cursor: pointer;\r\n  transition: color 100ms ease, background 100ms ease;\n}\n.dots-item[data-v-05011139]:not(.red):hover {\r\n  color: #fff;\r\n  background: #94aabb;\n}\n.dots-item.red[data-v-05011139] {\r\n  color: #e00c02;\n}\n.dots-item.red[data-v-05011139]:hover {\r\n  color: #fff;\r\n  background: #e00c02;\n}\n.dots-item[data-v-05011139]:not(:last-child) {\r\n  margin-bottom: 6px;\n}\r\n", ""]);

// exports
